export const PublisherStatus = Object.freeze({
	Pending: "pending",
	Approved: "approved",
	Rejected: "rejected",
});
